import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListJobScheduleManagement = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobScheduleManageMent`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListJobScheduleHistory = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobScheduleHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


export const UpdateStatusJobSchedule = async (param) => {
  let url = `${API_URL.Loader}/api/Job/UpdateStatusJobSchedule`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


export const DownloadFile = async (param) => {
  let url = `${API_URL.Loader}/api/Job/DownloadFile`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

